"use strict";



const local ='http://localhost:3381'
const cpanel ='https://viajespima.com' // cambiar por la url del sitio web.

exports.url  =  cpanel + '/api/Ncl_q3O/'; 

